import '../App.css';
import React from 'react';

//components
import Heading from '../components/Heading'
import Sidebar from '../components/Sidebar';
import Tabs from '../components/Tabs'
import Card from '../components/Card'
import Saved from '../components/Saved'

function Home() {
  return (
    <div className="App">
      <header className="App-header">
        <Heading/>
        <Sidebar />
        {/* <Tabs/> */}
        <Card />
        <Saved />
      </header>
    </div>
  );
}

export default Home;